import Vue from 'vue'
import {NetworkGraphResponse} from '@/tempData/NetworkGraphResponse'

export default {
  getLayer ({dispatch, getters}, params) {
    return Vue.http.get(params.endpoint, {
      params: {
        ...params.parameters,
        period_id: params.period,
        limit: 2000,
        workspace: getters.workspace
      }
    })
  },
  getFlow ({dispatch, getters}, period) {
    return Vue.http.get(getters.endpoint.flow, {
      params: {period_id: period, limit: 2000}
    })
  },
  setLayerToCache ({commit, getters}, params) {
    const cache = getters.mapLayersCache
    const {zoom, groupId, type, layerGroup} = params
    const selectedPeriod = getters.selectedPeriod ? getters.selectedPeriod.id : 1

    if (!cache[selectedPeriod]) {
      cache[selectedPeriod] = {}
    }
    const newLayer = {layer: layerGroup}

    if (!cache[selectedPeriod][groupId]) {
      cache[selectedPeriod][groupId] = {}
    }

    if (!cache[selectedPeriod][groupId][type]) {
      cache[selectedPeriod][groupId][type] = {}
    }
    if (zoom) {
      cache[selectedPeriod][groupId][type][zoom] = newLayer
    } else {
      cache[selectedPeriod][groupId][type] = newLayer
    }
  },
  getInfrastructure ({dispatch, getters}) {
    return Vue.http.get(getters.endpoint.infrastructure)
  },
  getAdmTerrDetail ({dispatch, getters}, id) {
    return Vue.http.get(getters.endpoint.admterritory + id)
  },
  getZoneDetail ({dispatch, getters}, id) {
    return Vue.http.get(getters.endpoint.zone + id, {
      params: {
        workspace: getters.workspace
      }
    })
  },
  getZoneStat ({dispatch, getters}, id) {
    return Vue.http.get(getters.endpoint.zoneStat + id, {
      params: {
        workspace: getters.workspace
      }
    })
  },
  patchZone ({dispatch, getters, commit}, params) {
    return Vue.http.patch(getters.endpoint.zone + params.id + "/", {
      ...params.payload,
      workspace: getters.workspace
    }).then(r => {
      commit('updateZones', r.body)
      dispatch('getAvailableAdmTerritories')
      return r.body
    })
  },
  createZone ({dispatch, getters, commit}, payload) {
    return Vue.http.post(getters.endpoint.zone, {
      ...payload,
      workspace: getters.workspace
    }).then(r => {
      commit('updateZones', r.body)
      dispatch('getAvailableAdmTerritories')
      return r.body
    })
  },
  getNetworkGraph({commit}) {
    //temp {...NetworkGraphResponse}
    commit('setNetworkGraph', {...NetworkGraphResponse})
  }
}



// WEBPACK FOOTER //
// ./src/store/workplace/actions.js